<template>
  <!-- UI -->
  <nav class="custom-nav blue-grey darken-3 hide-on-small-only"></nav>

  <nav class="nav-extended blue-grey darken-3 hide-on-small-only">
    <div class="nav-wrapper container">
      <a href="#!" class="brand-logo" @click.prevent="handleActive(home)">{{ home?.name }}</a>
      <ul class="right hide-on-med-and-down">
        <li v-for="tab in tabs" :key="tab.id" :class="{ 'active blue-grey darken-2': tab.id == currTab.id }">
          <a href="#" @click.prevent="handleActive(tab)">{{ tab.title }}</a>
        </li>
      </ul>
    </div>
    <div class="nav-content container">
      <a class="btn-floating btn-large halfway-fab waves-effect waves-light left red darken-2" title="Close"
        @click.prevent="handleRestart()">
        <i class="material-icons white-text">close</i>
      </a>
      <br />
    </div>
  </nav>

  <!-- Mobile only  -->
  <nav class="blue-grey darken-4 hide-on-large-only">
    <ul class="tabs tabs-transparent">
      <li v-for="tab in tabs" :key="tab.id" class="tab" :class="{ 'active': tab.id == currTab.id }">
        <a href="#" @click.prevent="handleActive(tab)">{{ tab?.title?.split(" ")[0] }}</a>
        <!-- <a href="#" @click.prevent="handleActive(tab)" v-else>{{ tab.title }}</a> -->
      </li>
    </ul>
  </nav>

  <!-- breadcrumbs -->
  <nav class="grey lighten-4 z-depth-0">
    <div class="container nav-wrapper">
      <div class="col s12">
        <router-link to="/" class="breadcrumb teal-text"><small> <i class="material-icons left">home</i>
            Dashboard</small></router-link>
        <router-link to="/auth" class="breadcrumb blue-grey-text text-darken-3"><small> Authorization
            Home</small></router-link>
        <span class="breadcrumb blue-grey-text pointable"><small>Review</small></span>
      </div>
    </div>
  </nav>

  <!-- search layer -->
  <!-- <div class="grey lighten-4">
    <div class="container section"></div>
  </div> -->


  <div class="container auth-view-shell sba-slide-in">
    <br />
    <div class="section center auth-detail-switch">
      <span v-for="tab in tabsState" :key="tab.id" :class="{
        'tab-custom-active': tab.id == currState.id,
        'tab-custom': tab.id != currState.id,
        'left blue-text': tab.title == 'Back',
      }" @click="handleActiveState(tab)">
        <i class="material-icons left" v-if="tab.title == 'Back'">arrow_back</i> {{ tab.title }}
      </span>
    </div>

    <LoadingDiv v-if="!isReady" />

    <div v-else>
      <div v-if="encounter">

        <div class="section">
          <div class="card z-depth-0 grey lighten-4">
            <br />
            <span class="new badge left" data-badge-caption="Scheme">{{
              encounter.scheme.name.toUpperCase()
            }}</span>

            <!-- Encounter -->
            <div class="card-content">
              <div class="row">
                <div class="col s8">
                  <p>{{ encounter?.provider?.name }}</p>
                  <h5>
                    {{ encounter.name.toUpperCase() }}
                    <sup><small><span class="chip black-text">{{
                      showAgeSex(encounter?.dob, encounter?.sex)
                          }}</span></small></sup>
                    <!-- &nbsp; <a href="#" class="orange-text"><i class="material-icons teal lighten-4" title="go back"
                        @click.prevent="handleRestart()">clear</i></a> -->
                  </h5>
                 <h5> <small> ({{ encounter.enrollee_number }})</small> </h5>
                  <p>
                    <br />
                    <span class="chip black white-text">
                      {{
                        new Date(encounter?.encounter_date).toLocaleString(undefined, {
                          weekday: "long",
                          year: "numeric",
                          month: "long",
                          day: "numeric",
                        })
                      }}
                    </span>
                  </p>
                </div>
                <div class="col s4">
                  <img :src="encounter.profile_img" width="192" class="circle responsive-img right"
                    v-if="encounter.profile_img" />
                  <img :src="`https://ui-avatars.com/api/?name=${encounter.name}&size=128`" width="192"
                    class="circle responsive-img right" v-else />
                </div>
              </div>
            </div>

            <!-- Entire Provider (diagnosis, claims) Display starts here -->
            <template v-if="currState.title == 'Review'">
              <div class="card grey lighten-4">

                <div id="claim"></div>

                <!-- Display Diagnosis -->
                <div class="row teal lighten-5">
                  <div class="col s12">
                    <div class="card-content yellow lighten-1">
                      <span class="black-text text-lighten-5">
                        <p>
                          <i class="material-icons black-text">bookmark_border</i>
                          Diagnosis: <span v-if="encounter?.diagnosis">{{ encounter?.diagnosis }}</span>
                          <span chip="yellow lighten-5" v-else><b>N/A</b></span>
                        </p>
                      </span>
                    </div>
                  </div>
                </div>

                <!-- Add new Auth -->
                <a class="btn-floating btn-large halfway-fab waves-effect waves-light"
                  :class="{ 'disabled': isSubmitting || lock || addAuthLocked, 'red': addAuth, 'blue': !addAuth }"
                  :title="addAuthLocked ? addAuthLockLabel : `${addAuth ? 'cancel' : 'Add Authorization'}`" @click.prevent="handleAddAuth">
                  <i class="material-icons">{{ addAuth ? "cancel" : "add" }}</i>
                </a>

                <!-- Claims Display Card -->
                <div class="card grey lighten-5" v-if="encounter.claims.length">
                  <div class="card-content">
                    <span class="card-title">Item(s)

                      <!-- <a
                    class="btn-medium waves-effect waves-light blue lighten-2 secondary-content chip right"><i
                      class="material-icons white-text" @click.prevent="handleAddAuth"
                      title="add New Item">add</i>
                    </a> -->

                    </span>

                    <!-- Auth Request -->
                    <ol id="item-list" class="collection">
                      <li
                        class="collection-item auth-line-item"
                        :class="[claimLineClass(claim), { 'is-review-readonly': isReviewReadOnlyClaim(claim), 'is-reviewed-authorization': isReviewedAuthorizationClaim(claim), 'is-claim-item': isBackendClaimItem(claim) }]"
                        v-for="claim in orderedReviewClaims"
                        :key="claim.id"
                      >
                        <template v-if="encounter.status == 'd'">

                          <!-- Deleted Encounter Items -->
                          <span class="auth-line-copy">
                            <s>{{ capWords(claim.item) }} x {{ claim.sent_qty }} (Amount Sent: ₦{{
                              Number(claim.sent_price)
                                .toFixed(2)
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            }})</s>
                            <b><span class="info-item tooltipped pointable" data-position="top"
                                :data-tooltip="claim.comment">
                                <i class="material-icons grey-text">help</i>
                              </span></b>

                            <!-- Authorizations (delete) -->
                            <span v-if="claim.authorization == 'y'">
                              => <s> ({{ claim.authorization_code }}) </s>
                            </span>
                          </span>

                        </template>

                        <template v-else-if="!canReviewAuthorization">
                          <!-- Closed / read-only review items -->
                          <span class="auth-line-copy" v-if="claim.authorization == 'y'">
                            <template v-if="isApprovedAsSent(claim)">
                              <b>{{ claim.item }}</b> x {{ claim.sent_qty }}
                              ({{ toMoney(claim.sent_price) }}) <span v-if="Number(claim.sent_price) != 0">-> (Approved)</span> ->
                              <span class="blue-text tooltipped pointable" data-position="top" :data-tooltip="claim.comment"
                                v-if="claim.comment">({{ claim.authorization_code }})</span>
                              <span class="black-text" v-else>({{ claim.authorization_code }})</span>

                              <span class="secondary-content pointable auth-readonly-line-icon"
                                :class="{ 'black-text': Number(claim.sent_price) == 0, 'green-text': Number(claim.sent_price) != 0 }"
                                :title="Number(claim.sent_price) == 0 ? 'Completed' : 'Approved'">
                                <i class="material-icons hide-on-small-only">check_circle</i>
                                <i class="tiny material-icons hide-on-med-and-up">check_circle</i>
                              </span>
                            </template>
                            <template v-else>
                              <b>{{ claim.item }}</b> x {{ claim.sent_qty }} (Charged:
                              {{ toMoney(claim.sent_price) }}) -> x {{ claim.approved_qty }} (Approved:
                              <b>{{ toMoney(claim.approved_price) }}</b>) ->
                              <span class="blue-text text-darken-4 tooltipped pointable" data-position="top"
                                :data-tooltip="claim.comment" v-if="claim.comment">({{ claim.authorization_code }})</span>
                              <span class="black-text" v-else>({{ claim.authorization_code }})</span>

                              <span
                                class="secondary-content green-text pointable auth-readonly-line-icon"
                                :class="{ tooltipped: claim.comment }"
                                data-position="top"
                                :data-tooltip="claim.comment"
                                :title="claim.comment || 'Approved'"
                              >
                                <i class="material-icons hide-on-small-only">check_circle</i>
                                <i class="tiny material-icons hide-on-med-and-up">check_circle</i>
                              </span>
                            </template>
                          </span>

                          <span class="auth-line-copy auth-normal-line" v-else-if="claim.authorization == 'n' && claim.status == 'a'">
                            <b>{{ claim.item }}</b> x {{ claim.sent_qty }} ({{ toMoney(claim.sent_price) }})
                            <span class="auth-care-state-chip is-normal is-static">Claim item</span>
                          </span>

                          <span class="auth-line-copy" v-else-if="claim.authorization == 'z' && claim.status == 'd'">
                            <s>
                              <span class="tooltipped pointable" data-position="top" :data-tooltip="claim.comment"
                                v-if="claim.comment">
                                <b>{{ claim.item }}</b> x {{ claim.sent_qty }} (Charged: {{ toMoney(claim.sent_price) }})
                              </span>

                              <span v-else>
                                <b>{{ claim.item }}</b> x {{ claim.sent_qty }} (Charged: {{ toMoney(claim.sent_price) }})
                              </span>
                            </s>

                            <span
                              class="secondary-content red-text pointable auth-readonly-line-icon"
                              :class="{ tooltipped: claim.comment }"
                              data-position="top"
                              :data-tooltip="claim.comment"
                              :title="claim.comment || 'Declined'"
                            >
                              <i class="material-icons hide-on-small-only">cancel</i>
                              <i class="tiny material-icons hide-on-med-and-up">cancel</i>
                            </span>
                          </span>

                          <span class="auth-line-copy" v-else-if="claim.authorization == 'z' && claim.status == 'a'">
                            <b>{{ claim.item }}</b> x {{ claim.sent_qty }} ({{ toMoney(claim.sent_price) }})
                            <span class="auth-care-state-chip is-primary is-static" v-if="isPrimaryCareApproval(claim)">Primary item</span>
                          </span>
                        </template>

                        <template v-else>
                          <!-- Pending Items -->
                          <span class="auth-line-copy" v-if="claim.authorization == 'z' && claim.status == 'a'">
                            <b>{{ capWords(claim.item) }}</b> x {{ claim.sent_qty }} (₦{{
                              Number(claim.sent_price)
                                .toFixed(2)
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            }})
                            <span class="auth-care-state-chip is-primary" :class="{ 'is-static': !canReviewAuthorization }" v-if="isPrimaryCareApproval(claim)">Primary item</span>

                            <!-- Reviewed claim -->
                            <span class="brown-text" v-if="claim.sent_price != claim.approved_price">
                              <b> =></b>

                              <span v-if="claim.sent_qty != claim.approved_qty"> x {{ claim.approved_qty }} </span>

                              <b> (₦{{
                                Number(claim.approved_price)
                                  .toFixed(2)
                                  .toString()
                                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                              }})<span class="info-item tooltipped pointable" data-position="top"
                                  :data-tooltip="capWords(claim.comment)">
                                  <i class="material-icons grey-text">help</i>
                                </span></b>
                            </span>

                            <!-- Authorizations (active) -->
                            <span v-if="claim.authorization == 'y'">
                              => ({{ claim.authorization_code }})
                              <span class="info-item tooltipped secondary-content pointable" data-position="top"
                                :data-tooltip="claim?.slug">
                                <i class="material-icons">lock_outline</i>
                              </span>
                            </span>

                            <!-- Actions -->
                            <span class="line-item-actions" v-if="!isSubmitting && canReviewAuthorization && isSecondaryCareApproval(claim)">
                              <template v-if="isSecondaryCareApproval(claim)">
                                <a href="#" class="secondary-content cancel-item"
                                  @click.prevent="handleReview(claim, 'delete')" title="delete">
                                  <i class="material-icons hide-on-small-only" :class="{
                                    'grey-text': deleteClaim?.id !== claim.id,
                                    'red-text': deleteClaim?.id === claim.id,
                                  }">cancel</i>
                                  <i class="tiny material-icons hide-on-med-and-up" :class="{
                                    'grey-text': deleteClaim?.id !== claim.id,
                                    'red-text': deleteClaim?.id === claim.id,
                                  }">cancel</i>
                                </a>

                                <a href="#" class="secondary-content edit-item"
                                  @click.prevent="handleReview(claim, 'edit')" title="edit">
                                  <i class="material-icons hide-on-small-only" :class="{
                                    'grey-text': editClaim?.id !== claim.id,
                                    'blue-text': editClaim?.id === claim.id,
                                  }">edit</i>
                                  <i class="tiny material-icons hide-on-med-and-up" :class="{
                                    'grey-text': editClaim?.id !== claim.id,
                                    'blue-text': editClaim?.id === claim.id,
                                  }">edit</i>
                                </a>
                              </template>

                              <a href="#" class="secondary-content return-normal-item"
                                @click.prevent="handleCareAuthorization(claim, 'normal')" title="Return to normal claim item">
                                <i class="material-icons hide-on-small-only grey-text">undo</i>
                                <i class="tiny material-icons hide-on-med-and-up grey-text">undo</i>
                              </a>
                            </span>
                          </span>

                          <!-- Normal Claim Items -->
                          <span class="auth-line-copy auth-normal-line" v-if="claim.authorization == 'n' && claim.status == 'a'">
                            <a href="#" class="auth-line-transition-prefix"
                              :class="{ 'is-returned': isReturnedNormalClaim(claim) }"
                              @click.prevent="handleCareAuthorization(claim, 'secondary')"
                              title="Keep as secondary care item"
                              v-if="!isSubmitting && canReviewAuthorization && isReturnedNormalClaim(claim)">
                              <i class="material-icons">undo</i>
                            </a>
                            <b>{{ capWords(claim.item) }}</b> x {{ claim.sent_qty }} ({{ toMoney(claim.sent_price) }})
                            <span class="auth-care-state-chip is-return" :class="{ 'is-static': !canReviewAuthorization }" v-if="isReturnedNormalClaim(claim)">Will return to normal claim item</span>
                            <span class="auth-care-state-chip is-normal" :class="{ 'is-static': !canReviewAuthorization }" v-else>Claim item</span>
                          </span>

                          <!-- Approved Items -->
                          <span class="auth-line-copy" v-if="claim.authorization == 'y'">
                            <b>{{ capWords(claim.item) }}</b> x {{ claim.sent_qty }} ({{ toMoney(claim.sent_price) }})
                            <span v-if="claim.authorization_code">({{ claim.authorization_code }})</span>
                            <span class="auth-reviewed-lock-chip" v-if="isReviewedAuthorizationClaim(claim)" title="Already reviewed">
                              <i class="material-icons">lock</i>
                              <span>Reviewed</span>
                            </span>
                          </span>

                          <!-- Deleted Items -->
                          <span class="auth-line-copy" v-if="claim.authorization == 'z' && claim.status == 'd'">
                            <s>{{ capWords(claim.item) }} x {{ claim.sent_qty }} (Amount Sent: ₦{{
                              Number(claim.sent_price)
                                .toFixed(2)
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            }})</s>
                            <b><span class="info-item tooltipped pointable" data-position="top"
                                :data-tooltip="capWords(claim.comment)">
                                <i class="material-icons grey-text">help</i>
                              </span></b>
                            <span class="auth-care-state-chip is-declined" :class="{ 'is-static': !canReviewAuthorization }" v-if="isDeclinedSecondaryCare(claim)">Declined</span>
                            <span class="auth-reviewed-lock-chip is-declined" v-else-if="isReviewedAuthorizationClaim(claim)" title="Already reviewed">
                              <i class="material-icons">lock</i>
                              <span>Reviewed</span>
                            </span>

                            <!-- Actions -->
                            <span class="line-item-actions" v-if="canReviewAuthorization && isDeclinedSecondaryCare(claim)">
                              <a href="#" class="secondary-content reset-item" @click.prevent="handleReset(claim)"
                                title="reset"><i class="small material-icons grey-text">refresh</i></a>
                            </span>
                          </span>
                        </template>
                      </li>
                    </ol>

                    <!-- Claims Submit -->
                    <div>
                      <ul class="auth-submit-summary" v-if="hasSubmitWork && canReviewAuthorization">
                        <li v-for="row in authSubmitSummaryRows" :key="row.id" :class="`is-${row.id}`">
                          <i class="material-icons">{{ row.icon }}</i>
                          <span>{{ row.label }}</span>
                        </li>
                      </ul>

                      <!-- Total -->
                      <ul id="item-list" class="collection" v-if="hasSubmitWork && canReviewAuthorization">
                        <li class="collection-item pull-right auth-total-row">
                          <span>
                            <b>Total</b> <em>(for approval)</em>:
                            <b><span class="red-text">₦{{ totalApproved(encounter?.claims) }}</span></b>
                          </span>
                          <span class="auth-grand-total">
                            Grand total: ₦{{ totalClaimValue(encounter?.claims) }}
                          </span>
                        </li>
                      </ul>

                      <div id="edit"></div>

                      <br />

                      <!-- Submit -->
                      <div class="row">
                        <!-- Breaker -->
                        <span class="co1 m9"></span>
                        <!-- Submit -->
                        <button class="waves-effect waves-light btn-large green col s12 m3 right modal-trigger auth-submit-action" v-if="hasSubmitWork && canReviewAuthorization" :class="{
                          disabled: isSubmitting || claimsLocked || !hasSubmitWork,
                        }" :disabled="isSubmitting || claimsLocked || !hasSubmitWork" data-target="confirmSubmit"><i class="large material-icons left">check_circle</i>{{
                          isSubmitting ? "Approving ..." : "Approve" }}
                        </button>
                      </div>

                      <!-- Confirmation -->
                      <Modal id="confirmSubmit" class="modal" :title="alertTitle" :message="authSubmitSummaryMessage"
                        @confirm="handleConfirm" />
                    </div>
                  </div>
                </div>

                <!-- Sumbmitting -->
                <div class="progress" v-if="isSubmitting">
                  <div class="indeterminate"></div>
                </div>

                <!-- <div class="white"><br /></div> -->

                <!-- Add claim -->
                <AddAuthItem
                  :turl="{ sid: encounter?.scheme_id, pid: encounter?.provider_id, opid: encounter?.provider?.opid }"
                  :reset="error" @update="handleAddAuthUpdate" v-if="addAuth" />

                <!-- Edit and Delete Claims -->
                <div class="card" :class="{ 'teal lighten-5': !error, 'red lighten-5': error }"
                  v-if="canReviewAuthorization && (editClaim || deleteClaim)">
                  <div class="card-content">
                    <div class="row">
                      <form class="col s12" @submit.prevent="handleUpdate()">
                        <div class="row">
                          <!-- Main  hide-on-small-only -->
                          <div class="input-field col s12 m6">
                            <input v-model="claim" id="claim" type="text" @focus="handleClear()" />
                            <label class="active" for="claim">Item</label>
                          </div>
                          <!-- Continue -->
                          <div class="input-field col s6 m3">
                            <input v-model="qty" @input="handlePricing" id="qty" type="number" />
                            <label class="active" for="qty">Quantity</label>
                          </div>
                          <div class="input-field col s6 m3">
                            <input v-model="amt" id="amt" type="number" readonly />
                            <label class="active" for="amt">Amount Charged</label>
                          </div>
                          <!-- Comment -->
                          <div class="input-field col s12">
                            <input v-model="comment" id="comment" type="text" required />
                            <label class="active" for="comment">Comment</label>
                          </div>

                          <div class="input-field col s12">
                            <a class="waves-effect waves-light btn-large black lighten-2 col s12 m2"
                              @click.prevent="handleClear()">
                              <i class="medium material-icons left">chevron_left</i>Back
                            </a>

                            <!-- Breaker -->
                            <span class="co1 m7"></span>

                            <!-- OK -->
                            <button class="waves-effect waves-light btn-large col s12 m3 right"
                              :class="{ 'indigo darken-2': editClaim?.id, 'red darken-2': deleteClaim?.id }">
                              <i class="medium material-icons left">{{
                                editClaim?.id ? "sync" : "cancel"
                              }}</i>{{ editClaim?.id ? "Edit Item" : "Delete Item" }}
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>

              </div>
            </template>

            <!-- Benefits -->
            <BenefitsDiv
              v-if="currState.title == 'Benefits' && benefitPlanId(encounter) && encounter?.client_id"
              :pid="benefitPlanId(encounter)"
              :cid="encounter.client_id"
            />

            <!-- History -->
            <HistoryAuth :enrolleeNumber="encounter.enrollee_number"
              :scheme-id="encounter.scheme_id || encounter.scheme?.id"
              v-if="currState.title == 'History'" />

            <!-- Utilization -->
            <UtilizationInsight
              v-if="currState.title == 'Utilization'"
              :encounter="encounter"
              @reset="handleActiveState(tabsState[0])"
            />

            <!-- Info -->
            <EncounterInfo
              v-if="currState.title == 'Info'"
              :encounter="encounter"
              mode="auth"
            />

          </div>
        </div>

      </div>

      <div class="section center" v-if="!encounter">
        <h6><img src="@/assets/img/no-user.png" width="256" class="circle responsive-img" /></h6>
      </div>


    </div>

  </div>
</template>

<script>
import { ref, onMounted, onUpdated, computed, watchEffect } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { toMoneyFx } from "@/composables/calFunction/cal.js";
import { ageSex } from "@/composables/fxLibrary/coreFx";
import postItem from "@/composables/postItem";
import { beginAdminAuthorizationRequest } from "@/composables/authorizationRealtimeCoordinator";
import getItem from "@/composables/getItem";
import AddAuthItem from "@/components/auth/AddAuthItemComponent.vue";
import BenefitsDiv from "@/components/plan/ShowBenefitComponent.vue";
import HistoryAuth from "@/components/auth/HistoryAuthComponent.vue";
import UtilizationInsight from "@/components/insight/UtilizationInsightComponent.vue";
import EncounterInfo from "@/components/encounter/EncounterInfoComponent.vue";
import LoadingDiv from "@/components/LoadingDiv.vue";
import Modal from "@/components/alerts/ModalComponent.vue";
import { ID_NUMBER, ABBR } from '@/laravel/config';
import { capWordsFx } from "@/composables/fxLibrary/coreFx.js";
import { siloMode } from '@/laravel/config';
import M from "materialize-css";


export default {
  name: "EnrolleeAuthComponent",
  props: ["encounterId"],
  components: { LoadingDiv, AddAuthItem, Modal, BenefitsDiv, HistoryAuth, UtilizationInsight, EncounterInfo },
  setup(props) {
    const lock = ref(false);
    const response = ref(null);
    const enrolleeDefault = ref([]);
    const originalClaimStates = ref({});
    const selectedItem = ref(null);
    const isReady = ref(false);
    const isLoading = ref(false);
    const isSubmitting = ref(false);
    const alertTitle = ref("Confirm");
    const alertMessage = ref("Are you sure? Kindly confirm items for accuracy. Once submitted, changes cannot be made.");
    const home = ref(null);
    const tabs = ref([]);
    const currTab = ref(null);
    const tabsState = ref([]);
    const currState = ref(null);
    const error = ref(false);
    const addAuth = ref(false);
    const editClaim = ref(null);
    const deleteClaim = ref(null);
    const standard = ref(null);
    const comment = ref(null);
    const claim = ref(null);
    const qty = ref(null);
    const amt = ref(null);
    const getResource = ref(null);
    const postResource = ref(null);

    // vue router
    const router = useRouter();

    // store
    const store = useStore();

    // start
    onMounted(() => {
      // page name
      document.title = "Approval Authorization";
    });

    // sort silo
    onMounted(() => {
      // sort
      getResource.value = getItem;
      postResource.value = postItem;
    });

    // start
    const validityChecker = (val) => {
      // only for remote calls
      if (siloMode) return;

      // checker
      if (ID_NUMBER !== val?.payer_id) {
        // return
        handleRestart();
      }
    }

    const snapshotClaimStates = (claims = []) => {
      return claims.reduce((states, claim) => {
        states[claim.id] = {
          authorization: claim.authorization,
          status: claim.status,
        };

        return states;
      }, {});
    };

    const originalClaimState = (claim) => {
      return originalClaimStates.value[claim?.id] || {};
    };

    const isOriginalActiveAuthorizationClaim = (claim) => {
      const original = originalClaimState(claim);

      return original.authorization === "z"
        && original.status === "a";
    };

    const isPrimaryCareApproval = (claim) => {
      const original = originalClaimState(claim);

      return original.authorization === "n"
        && original.status === "a"
        && claim?.authorization === "z"
        && claim?.status === "a";
    };

    const isSecondaryCareApproval = (claim) => {
      return isOriginalActiveAuthorizationClaim(claim)
        && claim?.authorization === "z"
        && claim?.status === "a";
    };

    const isReturnedNormalClaim = (claim) => {
      const original = originalClaimState(claim);

      return original.authorization === "z"
        && original.status === "a"
        && claim?.authorization === "n"
        && claim?.status === "a";
    };

    const isDeclinedSecondaryCare = (claim) => {
      const original = originalClaimState(claim);

      return original.authorization === "z"
        && original.status === "a"
        && claim?.authorization === "z"
        && claim?.status === "d";
    };

    const isReviewedAuthorizationClaim = (claim) => {
      if (claim?.authorization === "y") {
        return true;
      }

      return claim?.authorization === "z"
        && claim?.status === "d"
        && !isDeclinedSecondaryCare(claim);
    };

    const isReviewEditableClaim = (claim) => {
      return isSecondaryCareApproval(claim)
        || isReturnedNormalClaim(claim)
        || isDeclinedSecondaryCare(claim);
    };

    const isReviewReadOnlyClaim = (claim) => {
      if (!canReviewAuthorization.value || encounter.value?.status === "d") {
        return false;
      }

      return !isReviewEditableClaim(claim);
    };

    const isBackendClaimItem = (claim) => {
      const original = originalClaimState(claim);

      return original.authorization === "n"
        && original.status === "a"
        && claim?.authorization === "n"
        && claim?.status === "a";
    };

    const reviewClaimSortRank = (claim) => {
      const original = originalClaimState(claim);

      if (original.authorization === "z" && original.status === "a") {
        return 0;
      }

      if (claim?.authorization === "y" || (claim?.authorization === "z" && claim?.status === "d")) {
        return 1;
      }

      if (claim?.authorization === "n" && claim?.status === "a") {
        return 2;
      }

      return 3;
    };

    const orderedReviewClaims = computed(() => {
      return (encounter.value?.claims || [])
        .map((claim, index) => ({ claim, index }))
        .sort((a, b) => {
          const rank = reviewClaimSortRank(a.claim) - reviewClaimSortRank(b.claim);
          return rank || a.index - b.index;
        })
        .map(({ claim }) => claim);
    });

    const itemLabel = (count) => count === 1 ? "item" : "items";

    const isApprovedAsSent = (claim) => {
      return Number(claim?.sent_price) === Number(claim?.approved_price);
    };

    const claimLineClass = (claim) => {
      if (canReviewAuthorization.value || encounter.value?.status === "d") {
        return "";
      }

      if (claim?.authorization === "n" && claim?.status === "a") {
        return "";
      }

      if (claim?.authorization === "z" && claim?.status === "d") {
        return "red lighten-4";
      }

      if (claim?.authorization === "z" && claim?.status === "a") {
        return isPrimaryCareApproval(claim) ? "blue lighten-4" : "amber lighten-4";
      }

      if (claim?.authorization === "y") {
        if (Number(claim?.sent_price) === 0) {
          return "grey lighten-2";
        }

        if (!isApprovedAsSent(claim)) {
          return "blue lighten-4";
        }

        return "green lighten-4";
      }

      return "";
    };

    // start
    onMounted(() => {
      // load tab
      tabs.value.push({ id: 1, name: "Pre-Auth", title: "All", icon: "arrow_back", url: "auth", hash: null, });
      tabs.value.push({ id: 2, name: "Pre-Auth", title: "Add Auth", icon: "add_circle", url: "authAdd", hash: null, });

      // set default
      currTab.value = { id: null };
      // set home
      home.value = tabs.value.find(x => x.url === "auth");
    });


    onMounted(() => {
      // load tab
      // tabsState.value.push({ id: 1, title: "Back" });
      tabsState.value.push({ id: 2, title: "Review" });
      tabsState.value.push({ id: 3, title: "Benefits" });
      tabsState.value.push({ id: 4, title: "History" });
      tabsState.value.push({ id: 5, title: "Utilization" });
      tabsState.value.push({ id: 6, title: "Info" });
      // set default
      currState.value = tabsState.value[0]; // start from Review
    });

    // handle curr status
    const handleActive = (tab) => {
      // refer
      if (tab.hash) {
        router.push({ name: tab.url, hash: tab.hash });
      } else {
        router.push({ name: tab.url });
      }
    };

    // handle curr status
    const handleActiveState = (tab) => {
      // update show and components
      currState.value = tab;
    };

    const benefitPlanId = (val) => {
      return val?.plan_id || val?.plan?.id || val?.principal?.plan_id || val?.principal?.plan?.id || null;
    };

    const claimsLocked = computed(() => {
      const status = encounter.value?.cluster?.status;
      return siloMode && status && status !== "q";
    });

    const claimsLockLabel = computed(() => {
      const status = encounter.value?.cluster?.status;
      return status === "p" ? "Claims submitted" : "Claims closed";
    });

    const encounterAddLocked = computed(() => {
      const status = encounter.value?.status;
      return siloMode && status && status !== "q";
    });

    const addAuthLocked = computed(() => {
      return claimsLocked.value || encounterAddLocked.value;
    });

    const addAuthLockLabel = computed(() => {
      if (claimsLocked.value) {
        return claimsLockLabel.value;
      }

      return "Encounter submitted";
    });

    const hasActiveAuthorizationRequest = computed(() => {
      return (encounter.value?.claims || []).some(x => {
        const original = originalClaimState(x);
        return (original.authorization || x.authorization) === "z"
          && (original.status || x.status) === "a";
      });
    });

    const canReviewAuthorization = computed(() => {
      return !claimsLocked.value && hasActiveAuthorizationRequest.value;
    });

    // get function
    const getSingleItemFromApi = (table, id) => {
      (async () => {
        const { res, err } = await getResource.value(table, id);

        if (res.value) {

          const detailPayload = res.value.data;
          const authHistory = detailPayload.auth_history || detailPayload.claims || [];
          const reviewClaims = siloMode
            ? detailPayload.review_claims || detailPayload.vetting_claims || detailPayload.claims || []
            : detailPayload.vetting_claims || detailPayload.claims || [];

          // set default
          enrolleeDefault.value = JSON.parse(JSON.stringify({
            ...detailPayload,
            claims: authHistory,
          }));

          // get started
          let authEncounter = {
            ...detailPayload,
            claims: reviewClaims,
          };

          // oneProvider still uses the older generic encounter payload
          if (!siloMode) {
            authEncounter.claims = authEncounter.claims.filter(x => x.status === "a" && x.authorization === "z");
          }

          originalClaimStates.value = snapshotClaimStates(authEncounter.claims);

          // merge
          response.value = authEncounter;

          // SECURITY CHECKPOINT
          validityChecker(response.value);

          // // encounter
          // responseEncounter.value = res.value.data;
          // // auths
          // responseAuths.value = res.value.data.claims.filter(
          //   (x) => x.authorization != "n"
          // );
          // // sort auths
          // responseAuths.value.sort((a, b) => {
          //   return a.authorization.localeCompare(b.authorization);
          // });
        } else {
          error.value = err.value;
        }

        // page is ready
        isReady.value = true;
      })();
    };

    // toolTip
    const toolTip = () => {
      var elems = document.querySelectorAll(".tooltipped");
      M.Tooltip.init(elems, {});
    };

    // restart toolTip
    const restartComments = () => {
      // load comment
      setTimeout(() => {
        toolTip();
      }, 2000);
    };

    // load after data loads and updates
    watchEffect(() => {
      if (response.value) {
        restartComments();
      }
    });

    // starter
    onMounted(() => {
      // get items from function
      getSingleItemFromApi(siloMode ? "encounter/auth/detail" : "integration/oneprovider/auth", props.encounterId);
    });

    //from functions
    const capWords = (val) => {
      return capWordsFx(val);
    };

    // add up
    const totalApproved = (claims) => {
      let total = 0;
      claims?.forEach((x) => {
        if (x.approved_price && isSecondaryCareApproval(x)) {
          total = Number(total) + priceValue(x.approved_price);
        }
      });
      return total
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };

    const priceValue = (val) => {
      const amount = Number(String(val ?? 0).replace(/,/g, ""));
      return Number.isFinite(amount) ? amount : 0;
    };

    const totalClaimValue = (claims) => {
      let total = 0;

      claims?.forEach((x) => {
        if (x.status === "d") {
          return;
        }

        if (x.authorization === "y") {
          total = Number(total) + priceValue(x.approved_price);
          return;
        }

        total = Number(total) + priceValue(x.sent_price);
      });

      return total
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };

    // to Money
    const toMoney = (val) => {
      return toMoneyFx(val);
    }

    // ageSex
    const showAgeSex = (dob, sex) => {
      const { fx } = ageSex(dob, sex);
      return fx.value;
    };

    // scrollbar
    const resetScrollBar = () => {
      // Restore scrollbar (insurance)
      document.body.style.overflow = 'auto';
    };

    // alert
    onMounted(() => {
      // modal
      const elems = document.querySelectorAll(".modal");
      M.Modal.init(elems, {});

    });

    // alert
    onUpdated(() => {
      // modal
      const elems = document.querySelectorAll(".modal");
      M.Modal.init(elems, {});

    });

    // clear
    const handleClear = () => {
      // clear all
      claim.value = null;
      amt.value = null;
      qty.value = null;
      standard.value = null;
      comment.value = null;
      editClaim.value = null;
      deleteClaim.value = null;
    }

    // handle edit
    const handleReview = (val, type) => {
      if (!canReviewAuthorization.value || !isSecondaryCareApproval(val)) {
        return;
      }

      // refine claim
      claim.value = val.item;
      amt.value = val.sent_price;
      qty.value = val.sent_qty;
      standard.value = val.standard_price;
      comment.value = val.comment;

      // store all
      if (type === "edit") {
        if (editClaim.value?.id === val.id) {
          // clear all
          editClaim.value = null;
          handleClear();
          return;
        }
        editClaim.value = val;
        // clear delete lurking around
        deleteClaim.value = null;
      } else if (type === "delete") {
        if (deleteClaim.value?.id === val.id) {
          // clear all
          deleteClaim.value = null;
          handleClear();
          return;
        }
        deleteClaim.value = val
        // clear edit lurking around
        editClaim.value = null;
      } else {
        // clear all
        handleClear();
      }

      // top
      router.push({ hash: "#edit" });

    };

    // watch qty & price
    const handlePricing = () => {
      amt.value = (Number(qty.value) * Number(standard.value)).toFixed(2);
    };

    // handle reset
    const handleReset = (val) => {
      if (!canReviewAuthorization.value || !isDeclinedSecondaryCare(val)) {
        return;
      }

      // revert
      response.value.claims.forEach((x) => {
        if (x.id === val?.id) {
          x.approved_price = x.sent_price;
          x.approved_qty = x.sent_qty;
          x.comment = null;
          x.authorization = "z"; // return to at z
          x.status = "a" // turn to active
        }
      })
    }

    const handleCareAuthorization = (val, action) => {
      if (!canReviewAuthorization.value || isSubmitting.value) {
        return;
      }

      if (!["normal", "secondary"].includes(action)) {
        return;
      }

      if (action === "normal" && !isSecondaryCareApproval(val)) {
        return;
      }

      if (action === "secondary" && !isReturnedNormalClaim(val)) {
        return;
      }

      handleClear();

      response.value.claims.forEach((x) => {
        if (x.id !== val?.id) {
          return;
        }

        if (action === "secondary") {
          x.authorization = "z";
          x.authorization_code = null;
          x.status = "a";
          x.approved_qty = x.approved_qty || x.sent_qty;
          x.approved_price = x.approved_price || x.sent_price;
          x.comment = null;
        }

        if (action === "normal") {
          x.authorization = "n";
          x.authorization_code = null;
          x.status = "a";
          x.approved_qty = null;
          x.approved_price = null;
          x.comment = null;
        }
      });
    };

    // handle Emitted update
    const handleUpdate = () => {
      if (!canReviewAuthorization.value) {
        return;
      }

      if ((editClaim.value && !isSecondaryCareApproval(editClaim.value)) || (deleteClaim.value && !isSecondaryCareApproval(deleteClaim.value))) {
        handleClear();
        return;
      }

      if (amt.value && qty.value && claim.value && comment.value) {

        if (editClaim.value) {
          // edit here
          response.value.claims.forEach((x) => {
            if (x.id === editClaim.value?.id) {
              if (Number(amt.value) <= Number(x.sent_price)) { // approved_price // worked!
                x.approved_price = Number(amt.value).toFixed(2);
                x.approved_qty = qty.value;
                x.comment = comment.value;
                x.status = "a" // keep at active
              }
            }
          })
        }
        if (deleteClaim.value) {
          // delete here
          response.value.claims.forEach((x) => {
            if (x.id === deleteClaim.value?.id) {
              x.approved_price = 0;
              x.approved_qty = 0;
              x.comment = comment.value;
              x.authorization = "z"; // return to at z
              x.status = "d" // turn to delete
            }
          })
        }

        // load comments
        restartComments();

      }

      // clear all
      handleClear();

    };

    // hanlde restart
    const handleRestart = () => {
      // Go back Home
      router.push({
        name: "auth"
      });
    };

    // handle auth
    const handleAddAuth = () => {
      if (addAuthLocked.value) {
        return;
      }

      addAuth.value = !addAuth.value;
    }

    // handle auth
    const handleAddAuthUpdate = async (val) => {
      if (addAuthLocked.value) {
        return;
      }

      // clear old errors
      error.value = false;

      /* Auth
       Go Back
      */
      if (val?.id === 'clearAuth') {
        // start
        handleAddAuth();
      }

      /* AUTH
        Add New Authorization
        to the server
      */
      if (val?.id === 'addNewAuth') {

        // start
        isSubmitting.value = true;

        // update
        let newVal = {
          encounter_id: encounter.value.id,
          item: val.value.claim,
          sent_qty: val.value.qty,
          sent_price: val.value.amt,
          approved_qty: null,
          approved_price: null,
          standard_price: val.value.standard,
          authorization_code: null,
          authorization: "z",
          status: "a",
          slug: store.state.user.slug,
        };

        // post update
        const requestEcho = beginAdminAuthorizationRequest({ store, encounter: encounter.value, itemCount: 1 });
        const { res, err } = await postResource.value("claim", newVal);

        if (res.value) {
          requestEcho.finish(res.value.data);

          originalClaimStates.value = {
            ...originalClaimStates.value,
            ...snapshotClaimStates([res.value.data]),
          };

          // sort
          enrolleeDefault.value.claims.push({
            ...res.value.data,
          });

          response.value.claims.push({
            ...res.value.data,
          });

          // notify
          M.toast({
            html: "Item added <i class='material-icons'>check_circle</i>",
            classes: "green",
            displayLength: 4000,
            inDuration: 300,
            outDuration: 300,
          });

          // clear
          addAuth.value = false;

        } else {
          requestEcho.cancel();
          error.value = err.value;
        }

        // clear
        isSubmitting.value = false;

      }

      // top
      router.push({ hash: "#claim" });
    }

    // confirmation
    const handleConfirm = (val) => {
      if (!canReviewAuthorization.value || !hasSubmitWork.value) {
        return;
      }

      // call submit if confirmed
      if (val) {
        handleSubmit();
      }
    }

    // handle final submit
    const handleSubmit = async () => {
      if (!canReviewAuthorization.value || !hasSubmitWork.value) {
        return;
      }

      // start
      isSubmitting.value = true;

      // clean up encounter
      let keysToRemove = ["scheme", "claims", "created_at", "updated_at"];
      let newEncounter = {
        ...Object.fromEntries(
          Object.entries(encounter.value).filter(
            ([key]) => !keysToRemove.includes(key)
          )
        ),
      };

      // newEncounter.payer_id = 1; // this wont be necessary once enrollee is loaded properly

      // setup claims
      let newClaims = [];

      // clean up claims
      encounter.value.claims
        .filter((x) => isOriginalActiveAuthorizationClaim(x))
        .forEach((x) => {
          if (isSecondaryCareApproval(x)) {
            // load
            newClaims.push({ ...x, authorization: "y", authorization_code: `${ABBR}-AUTH-${x.id}`, slug: store.state.user.slug });
          } else if (isReturnedNormalClaim(x)) {
            // load
            newClaims.push({ ...x, authorization: "n", authorization_code: null, approved_qty: null, approved_price: null, comment: null, slug: store.state.user.slug });
          } else if (isDeclinedSecondaryCare(x)) {
            // load
            newClaims.push({ ...x, slug: store.state.user.slug });
          }
        });

      // put all together
      let newVal = { encounter: newEncounter, claims: newClaims };

      // post item
      const endpoint = siloMode ? "claim/update/bulk" : `integration/oneprovider/auth/${encounter.value.id}/decision`;
      const { res, err } = await postResource.value(endpoint, newVal);

      if (res.value) {

        // reset
        resetScrollBar();

        // fly away!
        handleRestart();


      } else {

        // manage error
        error.value = err.value;
        isSubmitting.value = false; // end

        // reset on fail
        resetScrollBar();

      }

    };

    // output encounter results
    const encounter = computed(() => {
      if (!response.value) {
        return null;
      } else {

        // for pending encounters only
        response.value.claims.forEach((x) => {
          if (!x.approved_price && x.status === "a" && x.authorization === "z") {
            x.approved_qty = x.sent_qty;
            x.approved_price = x.sent_price;
          }
        });

        // return
        return response.value;
      }
    });

    const authSubmitSummary = computed(() => {
      return (encounter.value?.claims || []).reduce((summary, x) => {
        if (isSecondaryCareApproval(x)) {
          summary.secondary += 1;
        }

        if (isReturnedNormalClaim(x)) {
          summary.normal += 1;
        }

        if (isDeclinedSecondaryCare(x)) {
          summary.declined += 1;
        }

        return summary;
      }, { secondary: 0, normal: 0, declined: 0 });
    });

    const authSubmitSummaryRows = computed(() => {
      const summary = authSubmitSummary.value;
      const rows = [];

      if (summary.secondary) {
        rows.push({
          id: "secondary",
          icon: "check_circle",
          label: `Approve ${summary.secondary} secondary care ${itemLabel(summary.secondary)}`,
        });
      }

      if (summary.normal) {
        rows.push({
          id: "normal",
          icon: "undo",
          label: `Return ${summary.normal} ${itemLabel(summary.normal)} to normal claim ${itemLabel(summary.normal)}`,
        });
      }

      if (summary.declined) {
        rows.push({
          id: "declined",
          icon: "cancel",
          label: `Decline ${summary.declined} secondary care ${itemLabel(summary.declined)}`,
        });
      }

      return rows;
    });

    const authSubmitSummaryMessage = computed(() => {
      if (!authSubmitSummaryRows.value.length) {
        return alertMessage.value;
      }

      return `${alertMessage.value} ${authSubmitSummaryRows.value.map((x) => x.label).join(". ")}. Approved total: ₦${totalApproved(encounter.value?.claims)}.`;
    });

    const hasSubmitWork = computed(() => authSubmitSummaryRows.value.length > 0);


    return {
      lock,
      enrolleeDefault,
      authSubmitSummaryRows,
      authSubmitSummaryMessage,
      capWords,
      toMoney,
      showAgeSex,
      handleRestart,
      handleAddAuth,
      handleAddAuthUpdate,
      handleCareAuthorization,
      handleActive,
      handleActiveState,
      handlePricing,
      handleReset,
      handleReview,
      handleUpdate,
      handleClear,
      handleConfirm,
      handleSubmit,
      alertTitle,
      alertMessage,
      selectedItem,
      totalApproved,
      totalClaimValue,
      benefitPlanId,
      isReady,
      isLoading,
      isSubmitting,
      home,
      tabs,
      tabsState,
      currTab,
      currState,
      error,
      addAuth,
      editClaim,
      deleteClaim,
      encounter,
      orderedReviewClaims,
      hasSubmitWork,
      isPrimaryCareApproval,
      isSecondaryCareApproval,
      isReturnedNormalClaim,
      isDeclinedSecondaryCare,
      isReviewedAuthorizationClaim,
      isReviewReadOnlyClaim,
      isBackendClaimItem,
      isApprovedAsSent,
      claimLineClass,
      hasActiveAuthorizationRequest,
      canReviewAuthorization,
      claimsLocked,
      claimsLockLabel,
      encounterAddLocked,
      addAuthLocked,
      addAuthLockLabel,
      standard,
      comment,
      claim,
      qty,
      amt,
    };
  },
};
</script>

<style scoped>
.auth-view-shell > .section,
.auth-view-shell > div,
.auth-view-shell .card {
  animation: sbaSlideIn var(--sba-slide-duration, 260ms) ease-out both;
}

.progress {
  margin-top: -15px;
}

.spacer5 {
  padding-top: 5px;
  padding-bottom: 5px;
}

.spacerTop10 {
  padding-top: 10px;
  padding-bottom: 0px;
}

.edit-black-item:hover .material-icons.black-text,
.edit-black-item:hover .material-icons.grey-text::before {
  color: rgb(21, 21, 206) !important;
}

.edit-item:hover .material-icons.grey-text,
.edit-item:hover .material-icons.grey-text::before {
  color: rgb(21, 21, 206) !important;
}

.cancel-item:hover .material-icons.grey-text,
.cancel-item:hover .material-icons.grey-text::before {
  color: rgb(214, 16, 16) !important;
}

.custom-nav {
  height: 15px;
}

.nav-extended .nav-wrapper {
  padding: 0 20px;
}

.brand-logo {
  font-weight: 300;
  font-size: 1.5rem;
}

.nav-wrapper ul li a {
  font-weight: 400;
  padding: 0 15px;
}

.nav-content {
  min-height: 20px;
}

.auth-view-shell .auth-line-item {
  box-sizing: border-box;
  min-height: 54px;
  padding-right: 166px;
  position: relative;
}

.auth-view-shell .auth-line-item.is-reviewed-authorization::marker {
  color: #607d8b;
  content: "    R. ";
  font-weight: 800;
}

.auth-view-shell .auth-line-item.is-claim-item::marker {
  color: #607d8b;
  content: "    C. ";
  font-weight: 800;
}

.auth-view-shell .auth-line-item.is-review-readonly {
  background: #fefefe !important;
  color: #546e7a;
}

.auth-view-shell .auth-line-item.is-review-readonly .auth-line-copy,
.auth-view-shell .auth-line-item.is-review-readonly .auth-line-copy b,
.auth-view-shell .auth-line-item.is-review-readonly .auth-line-copy s,
.auth-view-shell .auth-line-item.is-review-readonly .auth-line-copy .brown-text,
.auth-view-shell .auth-line-item.is-review-readonly .auth-line-copy .blue-text,
.auth-view-shell .auth-line-item.is-review-readonly .auth-line-copy .black-text,
.auth-view-shell .auth-line-item.is-review-readonly .auth-line-copy .red-text {
  color: #546e7a !important;
}

.auth-view-shell .auth-line-item.is-review-readonly .auth-care-state-chip {
  background: #fafcfd;
  border-color: #edf2f4;
  color: #607d8b;
}

.auth-view-shell .auth-line-copy {
  display: block;
  max-width: 100%;
  min-width: 0;
  overflow-wrap: break-word;
}

.auth-view-shell .line-item-actions {
  align-items: center;
  display: inline-flex;
  gap: 6px;
  justify-content: flex-end;
  position: absolute;
  right: 24px;
  top: 50%;
  transform: translateY(-50%);
  white-space: nowrap;
}

.auth-view-shell .line-item-actions .secondary-content {
  float: none;
  margin-left: 0;
  position: static;
}

.auth-view-shell .auth-readonly-line-icon.secondary-content {
  align-items: center;
  display: inline-flex;
  float: none;
  height: 32px;
  justify-content: center;
  margin-left: 0;
  position: absolute;
  right: 24px;
  top: 50%;
  transform: translateY(-50%);
  width: 32px;
}

.auth-view-shell .auth-readonly-line-icon i {
  line-height: 1;
}

.auth-view-shell .auth-reviewed-lock-chip {
  align-items: center;
  background: #f4f7f8;
  border: 1px solid #d6e0e4;
  border-radius: 999px;
  color: #455a64;
  display: inline-flex;
  font-size: 0.72rem;
  font-weight: 750;
  gap: 5px;
  line-height: 1.1;
  padding: 5px 9px;
  position: absolute;
  right: 24px;
  top: 50%;
  transform: translateY(-50%);
  white-space: nowrap;
}

.auth-view-shell .auth-reviewed-lock-chip.is-declined {
  background: #fff5f5;
  border-color: #ffcdd2;
  color: #b71c1c;
}

.auth-view-shell .auth-reviewed-lock-chip i {
  font-size: 15px;
  line-height: 1;
}

.auth-view-shell .line-item-actions a {
  align-items: center;
  border-radius: 50%;
  display: inline-flex;
  height: 30px;
  justify-content: center;
  position: relative;
  width: 30px;
}

.auth-view-shell .line-item-actions a + a::before {
  background: #c4d3d9;
  content: "";
  height: 20px;
  left: -3px;
  position: absolute;
  top: 5px;
  width: 1px;
}

.auth-view-shell .line-item-actions i {
  line-height: 1;
}

.auth-line-transition-prefix {
  align-items: center;
  background: #eef7f8;
  border: 1px solid #c6e2e7;
  border-radius: 50%;
  color: #00796b;
  display: inline-flex;
  height: 28px;
  justify-content: center;
  margin-right: 8px;
  vertical-align: middle;
  width: 28px;
}

.auth-line-transition-prefix:hover,
.auth-line-transition-prefix:focus {
  background: #d8f0ef;
}

.auth-line-transition-prefix.is-returned {
  background: #fff8e1;
  border-color: #ffcc80;
  color: #ef6c00;
}

.auth-line-transition-prefix i {
  color: inherit;
  font-size: 18px;
  line-height: 1;
}

.auth-care-state-chip {
  background: #eef2f4;
  border: 1px solid #d6e0e4;
  border-radius: 999px;
  color: #455a64;
  display: inline-flex;
  font-size: 0.72rem;
  font-weight: 700;
  line-height: 1.2;
  margin-left: 8px;
  padding: 4px 8px;
  vertical-align: middle;
}

.auth-care-state-chip.is-static {
  margin-left: 0;
  position: absolute;
  right: 24px;
  top: 50%;
  transform: translateY(-50%);
}

.auth-care-state-chip.is-secondary {
  background: #e8f5e9;
  border-color: #c8e6c9;
  color: #2e7d32;
}

.auth-care-state-chip.is-primary {
  background: #e3f2fd;
  border-color: #bbdefb;
  color: #1565c0;
}

.auth-care-state-chip.is-normal {
  background: #f8fafb;
  border-color: #dbe5e9;
  color: #607d8b;
}

.auth-care-state-chip.is-return {
  background: #fff8e1;
  border-color: #ffcc80;
  color: #ef6c00;
}

.auth-care-state-chip.is-approved {
  background: #e8f5e9;
  border-color: #a5d6a7;
  color: #1b5e20;
}

.auth-care-state-chip.is-declined {
  background: #ffebee;
  border-color: #ffcdd2;
  color: #b71c1c;
}

.auth-submit-action {
  align-items: center;
  background: #0b8f78 !important;
  border: 1px solid #087a68;
  border-radius: 7px;
  box-shadow: 0 12px 24px -16px rgba(8, 122, 104, 0.95);
  color: #ffffff !important;
  display: inline-flex;
  font-size: 0.95rem;
  font-weight: 800;
  justify-content: center;
  letter-spacing: 0;
  min-height: 52px;
  text-transform: none;
  transition: background-color 0.18s ease, box-shadow 0.18s ease, transform 0.18s ease;
}

.auth-submit-action:hover,
.auth-submit-action:focus {
  background: #087a68 !important;
  box-shadow: 0 16px 30px -18px rgba(8, 122, 104, 0.95);
  transform: translateY(-1px);
}

.auth-submit-action.disabled,
.auth-submit-action:disabled {
  background: #cfd8dc !important;
  border-color: #cfd8dc;
  box-shadow: none;
  color: #607d8b !important;
  transform: none;
}

.auth-submit-action i.left {
  color: inherit;
  font-size: 22px;
  line-height: 1;
  margin-right: 10px;
}

.auth-view-shell .auth-total-row {
  align-items: center;
  background: #f8fafb;
  color: #263238;
  display: flex;
  flex-wrap: wrap;
  gap: 10px 18px;
  justify-content: space-between;
}

.auth-view-shell .auth-grand-total {
  color: #000000;
  margin-left: auto;
}

.return-normal-item:hover .material-icons.grey-text,
.return-normal-item:hover .material-icons.grey-text::before {
  color: #ef6c00 !important;
}

.auth-submit-summary {
  display: grid;
  gap: 9px;
  list-style: none;
  margin: 0 0 14px;
  padding: 0;
}

.auth-submit-summary li {
  align-items: center;
  background: #f8fafb;
  border: 1px solid #e1e8eb;
  border-radius: 6px;
  color: #263238;
  display: flex;
  font-weight: 700;
  gap: 10px;
  min-height: 42px;
  padding: 9px 20px;
}

.auth-submit-summary i {
  align-items: center;
  background: #00796b;
  border-radius: 50%;
  color: #ffffff;
  display: inline-flex;
  flex: 0 0 auto;
  font-size: 16px;
  height: 24px;
  justify-content: center;
  line-height: 1;
  width: 24px;
}

.auth-submit-summary li.is-secondary i {
  background: #2e7d32;
}

.auth-submit-summary li.is-primary i {
  background: #1565c0;
}

.auth-submit-summary li.is-normal i {
  background: #ef6c00;
}

.auth-submit-summary li.is-declined i {
  background: #c62828;
}

@media only screen and (max-width: 992px) {
  .auth-detail-switch {
    align-items: stretch;
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    justify-content: flex-start;
    padding: 10px 12px;
    text-align: left;
  }

  .auth-detail-switch .tab-custom,
  .auth-detail-switch .tab-custom-active {
    align-items: center;
    background: #f8fafb;
    border: 1px solid #dbe5e9;
    border-radius: 6px;
    box-sizing: border-box;
    display: inline-flex;
    flex: 1 1 150px;
    font-size: 0.76rem;
    justify-content: center;
    margin: 0;
    min-height: 38px;
    padding: 0 10px;
    text-align: center;
  }

  .auth-detail-switch .tab-custom-active {
    background: #263238;
    border-color: #263238;
    color: #ffffff;
  }

  .auth-view-shell .auth-line-item {
    padding-right: 20px;
  }

  .auth-view-shell .line-item-actions {
    background: #f8fafb;
    border: 1px solid #dbe5e9;
    border-radius: 999px;
    box-shadow: 0 8px 18px -18px rgba(38, 50, 56, 0.72);
    gap: 10px;
    margin-top: 10px;
    padding: 4px;
    position: static;
    transform: none;
    width: max-content;
  }

  .auth-view-shell .line-item-actions a {
    height: 34px;
    width: 34px;
  }

  .auth-view-shell .line-item-actions a + a::before {
    display: none;
  }

  .auth-view-shell .line-item-actions .tiny.material-icons {
    font-size: 1.25rem;
  }

  .auth-view-shell .auth-readonly-line-icon.secondary-content {
    display: inline-flex;
    margin-left: 8px;
    position: static;
    transform: none;
    vertical-align: middle;
  }

  .auth-view-shell .auth-reviewed-lock-chip {
    margin-left: 8px;
    position: static;
    transform: none;
    vertical-align: middle;
  }

  .auth-care-state-chip.is-static {
    margin-left: 8px;
    position: static;
    transform: none;
  }

}

@media only screen and (max-width: 700px) {
  .custom-nav,
  .nav-extended.hide-on-small-only {
    display: none;
  }

  .auth-view-shell {
    width: calc(100% - 24px);
  }

  .auth-view-shell > br {
    display: none;
  }

  .auth-view-shell > .section {
    padding-top: 14px;
  }

  .auth-view-shell .card,
  .auth-view-shell .card-panel {
    border-radius: 8px;
    overflow-wrap: anywhere;
  }

  .auth-view-shell .card-content,
  .auth-view-shell .card-panel {
    padding: 16px;
  }

  .auth-view-shell .row {
    margin-bottom: 0;
  }

  .auth-view-shell .row > .col {
    width: 100% !important;
  }

  .auth-view-shell img.responsive-img.right {
    float: none !important;
    margin-top: 14px;
    max-width: 96px;
  }

  .auth-view-shell h5 {
    font-size: 1.25rem;
    line-height: 1.35;
  }

  .auth-view-shell .chip {
    height: auto;
    line-height: 1.25;
    margin: 3px 2px;
    min-height: 30px;
    white-space: normal;
  }

  .auth-view-shell .collection,
  .auth-view-shell .collection-item {
    overflow-wrap: anywhere;
  }

  .auth-view-shell .secondary-content {
    float: none;
    margin-left: 8px;
  }

  .auth-view-shell .line-item-actions .secondary-content {
    float: none;
    margin-left: 0;
    position: static;
  }

  .auth-view-shell .btn,
  .auth-view-shell .btn-large {
    min-height: 40px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .auth-view-shell > .section,
  .auth-view-shell > div,
  .auth-view-shell .card {
    animation: none;
  }
}
</style>
